import React, { useState, useEffect } from 'react';
import { Modal, Input, Button } from 'antd';
import { useAppDispatch } from '@app/hooks/reduxHooks';
import { updateRemark } from '@app/store/slices/orderSlice';

interface RemarkEditModalProps {
  orderId: number;
  initialRemark: string;
  open: boolean;
  onClose: () => void;
  onSuccess: (newRemark: string) => void;
}

const RemarkEditModal: React.FC<RemarkEditModalProps> = ({ orderId, initialRemark, open, onClose, onSuccess }) => {
  const dispatch = useAppDispatch();
  const [remark, setRemark] = useState(initialRemark);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setRemark(initialRemark);
  }, [initialRemark, open]);

  const handleSave = async () => {
    try {
      setLoading(true);
      console.log('🔥 RemarkEditModal.handleSave - Dispatching updateRemark with:', { orderId, remark });
      const result = await dispatch(updateRemark({ orderId, remark })).unwrap();
      console.log('🔥 RemarkEditModal.handleSave - updateRemark result:', result);
      onSuccess(remark);
      onClose();
    } catch (error) {
      console.error('Error updating remark:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setRemark(initialRemark);
    onClose();
  };

  return (
    <Modal
      title="Cập nhật ghi chú"
      open={open}
      onCancel={handleCancel}
      footer={[
        <Button key="cancel" onClick={handleCancel}>
          Hủy
        </Button>,
        <Button key="save" type="primary" loading={loading} onClick={handleSave}>
          Lưu
        </Button>,
      ]}
    >
      <Input.TextArea
        rows={4}
        placeholder="Nhập ghi chú..."
        value={remark}
        onChange={(e) => setRemark(e.target.value)}
      />
    </Modal>
  );
};

export default RemarkEditModal;
